export default "__VITE_ASSET__D1wu$Joi__"